import React from "react";
import { useDispatch } from "react-redux";

import { fetchDataViewStandBy } from './_redux/lppsCrud';

import StandardNew from '../../components/standartComponents/standardNew'
import { getUser} from '../../../index';

export default function LppNew(props) {

  const dispatch = useDispatch();

  const newstd = {
    name: '',
    classification: 'Selecione uma opção',
    pilar: 'Selecione uma opção',
    transfer: 'Selecione uma opção',
    applicableToNewColleague: 'Selecione uma opção',
    StructureId: null,
    standardType: "LPP",
    userId: getUser().id,
    status: 1,
    version: 1,
    steps: [],
    trainingUsers: [],
    epis: [],
    tools: [],
    lpps: [],
    images: []
  }

  const defaultDadosBasicos = [
    {
      name: 'classification',
      desc: 'Classificação',
      class: 'col-4',
      options: ['Conhecimento Básico', 'Caso de Melhoria', 'Caso de Problema', 'Transferência de Conhecimento']
    },
    {
      name: 'pilar', desc: 'Pilar', class: 'col-4', options:
            ['Pilar MA', 'Pilar MP', 'Pilar MEGA', 'Pilar E&T', 'Pilar Q', 'Pilar SHE Segurança',
             'Pilar SHE Meio Ambiente','Pilar Lean', 'Pilar I&I', 'Pilar Digital', 'Técnico Operacional']      
      },
    { name: 'transfer', desc: 'Transferência de atividade', class: 'col-4', options: ['Não','Sim']},
    {
      name: 'applicableToNewColleague',
      desc: 'Aplicável a novo colaborador',
      class: 'col-6',
      options: [{ key: 'false', value: 'Não' },{key: 'true', value: 'Sim'}]
    }
  ]

    return StandardNew(defaultDadosBasicos, props, newstd, fetchDataViewStandBy, 'lpp');
}
